import { render, staticRenderFns } from "./CommunicationEmployerGroups.vue?vue&type=template&id=0c4fd935&scoped=true"
import script from "./CommunicationEmployerGroups.vue?vue&type=script&lang=ts"
export * from "./CommunicationEmployerGroups.vue?vue&type=script&lang=ts"
import style0 from "./CommunicationEmployerGroups.vue?vue&type=style&index=0&id=0c4fd935&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4fd935",
  null
  
)

export default component.exports